import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import LocalizedLink from "@/components/LocalizedLink";

const CTASection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 lg:py-28 bg-gradient-royal text-primary-foreground relative overflow-hidden">
      {/* Decorative gold accent */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-gold" />
      
      <div className="container mx-auto px-4 text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-2xl mx-auto"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold mb-6">
            {t("cta.title")}
          </h2>
          <p className="text-base text-primary-foreground/70 font-body mb-10">
            {t("cta.description")}
          </p>
          <LocalizedLink
            to="/apply"
            className="inline-flex items-center gap-2 px-10 py-4 bg-accent text-accent-foreground font-body font-semibold text-base rounded-md hover:opacity-90 transition-all shadow-gold group"
          >
            {t("cta.button")}
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </LocalizedLink>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
